import { defineChain } from "viem";
import { arbitrum, arbitrumSepolia, base, baseSepolia, bsc, bscTestnet } from "viem/chains";

export const realTestnet = defineChain({
	id: 1992,
	name: "Real Testnet",
	nativeCurrency: {
		name: "Ether",
		symbol: "ETH",
		decimals: 18
	},
	rpcUrls: {
		default: {
			http: [import.meta.env.VITE_REAL_TESTNET_RPC || "https://explorer.reallayer.com/api/eth-rpc"]
		}
	},
	blockExplorers: {
		default: {
			name: "Real Explorer",
			url: "https://explorer.reallayer.com"
		}
	},
	contracts: {
		multicall3: {
			address: "0xca11bde05977b3631167028862be2a173976ca11"
		}
	}
});

// Supported chains — Base Sepolia is primary default, then testnets, then mainnets
export const supportedChains = [baseSepolia, bscTestnet, realTestnet, arbitrumSepolia, arbitrum, base, bsc] as const;
export type SupportedChainId = (typeof supportedChains)[number]["id"];

// Default chain - Base Sepolia for the main app (derivatives use Arbitrum Sepolia via action-level guards)
export const defaultChain = baseSepolia;

export { arbitrum, arbitrumSepolia, base, baseSepolia, bsc, bscTestnet };
